export default __webpack_public_path__ + "static/telecel_play-37581d2416e8e798a2b5221c056ff5d0.webp";